import axios from '../config/axios';

const POST_LOGIN = 'api/users/connect';


export const postLogin = (data) => {
    return axios.post(POST_LOGIN, data);
};

